/**
 * menu component
 */
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Renderer2,
  ViewContainerRef,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';

@Component({
  selector: 'ispm-layout-engine-menu',
  templateUrl: './layout-engine-menu.component.html',
  styleUrls: ['./layout-engine-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('Menu')
export class LayoutEngineMenuComponent implements OnInit, IWidgetItem, OnDestroy {
  widgetUpdateValueCallback: (value) => void;
  config;
  data;
  @ViewChild('slidemenuContent', { static: false, read: ViewContainerRef}) slidemenuContent;

  /**
   * set layout menu widget config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
   this.config = _itemConfig.widgetPayload;
  }

  /**
   * set layout menu widget config
   * @param widgetData
   */
  set widgetData(widgetData: any) {
    this.data = widgetData;
  }

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
  }

  /**
   * Show slide menu in mobile view
   */
  showSlideMenu() {
    this.renderer.removeClass(this.slidemenuContent.element.nativeElement, 'slide-is-closed');
    this.renderer.addClass(this.slidemenuContent.element.nativeElement, 'slide-is-open');
  }

  /**
   * Hide slide menu in mobile view
   */
  closeSlideMenu() {
    this.renderer.removeClass(this.slidemenuContent.element.nativeElement, 'slide-is-open');
    this.renderer.addClass(this.slidemenuContent.element.nativeElement, 'slide-is-closed');
  }

  ngOnDestroy(): void {
    this.renderer = null;
  }
}
